module.exports = __webpack_public_path__ + "media/images/admin/icons/airplay-904fa203d3b00466461eadbf9b38e9be.svg";